import { useState } from 'react';

import Checkbox from '@cartwhl/ui/atoms/Checkbox';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import Modal from '@cartwhl/ui/molecules/Modal';

import { useLocalStorage } from 'hooks/useLocalStorage';
import { uiStore } from 'stores';

const key = 'skipNewSessionModal';

export default function NewSessionModal({ close }: { close: () => void }) {
  const [checked, setChecked] = useState(false);
  const [skipModal, setSkipModal] = useLocalStorage(key, false);

  if (skipModal) return null;

  return (
    <Modal
      title={`New sessions automatically`}
      open={true}
      footer={
        <Checkbox
          id="sessions-modal-checkbox"
          setChecked={setChecked}
          checked={checked}
          label="Don't show again"
          variant="checkbox"
          color="settings"
        />
      }
    >
      <Text as="p" variant="studio/body/md" className="max-w-[636px] leading-5">
        Cartwheel will create a new session if your prompt seems unrelated to
        your current motion. This will help keep your sessions focused on a
        single topic. Your previous session can be found in your History panel.
      </Text>

      <div className="mt-6 flex justify-between">
        <Button
          variant="secondary"
          onClick={() => {
            uiStore.setOpenPanel('history');
            close();
          }}
        >
          See history
        </Button>
        <Button
          variant="primary"
          onClick={() => {
            if (checked) {
              setSkipModal(true);
            }
            close();
          }}
        >
          Got it
        </Button>
      </div>
    </Modal>
  );
}
